import {
  createMemberAbout as publicCreateMemberAbout,
  updateMemberAbout as publicUpdateMemberAbout,
  deleteMemberAbout as publicDeleteMemberAbout,
  getMemberAbout as publicGetMemberAbout,
  getMyMemberAbout as publicGetMyMemberAbout,
  queryMemberAbouts as publicQueryMemberAbouts,
  typedQueryMemberAbouts as publicTypedQueryMemberAbouts,
} from './members-about-v2-member-about-members-about.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  MemberAboutQuery,
  MemberAboutsQueryBuilder,
  typedQueryMemberAbouts as universalTypedQueryMemberAbouts,
} from './members-about-v2-member-about-members-about.universal.js';
import { onMemberAboutCreated as publicOnMemberAboutCreated } from './members-about-v2-member-about-members-about.public.js';
import { onMemberAboutDeleted as publicOnMemberAboutDeleted } from './members-about-v2-member-about-members-about.public.js';
import { onMemberAboutUpdated as publicOnMemberAboutUpdated } from './members-about-v2-member-about-members-about.public.js';

function customQueryMemberAbouts(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryMemberAbouts(httpClient)(),
    typedQueryFunction: (query: MemberAboutQuery) =>
      publicTypedQueryMemberAbouts(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): MemberAboutsQueryBuilder;
  function overloadedQuery(
    query: MemberAboutQuery
  ): ReturnType<typeof universalTypedQueryMemberAbouts>;
  function overloadedQuery(query?: MemberAboutQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createMemberAbout: MaybeContext<
  BuildRESTFunction<typeof publicCreateMemberAbout> &
    typeof publicCreateMemberAbout
> = /*#__PURE__*/ createRESTModule(publicCreateMemberAbout);
export const updateMemberAbout: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMemberAbout> &
    typeof publicUpdateMemberAbout
> = /*#__PURE__*/ createRESTModule(publicUpdateMemberAbout);
export const deleteMemberAbout: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMemberAbout> &
    typeof publicDeleteMemberAbout
> = /*#__PURE__*/ createRESTModule(publicDeleteMemberAbout);
export const getMemberAbout: MaybeContext<
  BuildRESTFunction<typeof publicGetMemberAbout> & typeof publicGetMemberAbout
> = /*#__PURE__*/ createRESTModule(publicGetMemberAbout);
export const getMyMemberAbout: MaybeContext<
  BuildRESTFunction<typeof publicGetMyMemberAbout> &
    typeof publicGetMyMemberAbout
> = /*#__PURE__*/ createRESTModule(publicGetMyMemberAbout);
export const queryMemberAbouts: MaybeContext<
  BuildRESTFunction<typeof customQueryMemberAbouts> &
    typeof customQueryMemberAbouts
> = /*#__PURE__*/ createRESTModule(customQueryMemberAbouts);
/**
 * Triggered when a member's "About" section content is created.
 */
export const onMemberAboutCreated: BuildEventDefinition<
  typeof publicOnMemberAboutCreated
> &
  typeof publicOnMemberAboutCreated = createEventModule(
  publicOnMemberAboutCreated
);
/**
 * Triggered when a member's "About" section content is deleted.
 */
export const onMemberAboutDeleted: BuildEventDefinition<
  typeof publicOnMemberAboutDeleted
> &
  typeof publicOnMemberAboutDeleted = createEventModule(
  publicOnMemberAboutDeleted
);
/**
 * Triggered when a member's "About" section content is updated.
 */
export const onMemberAboutUpdated: BuildEventDefinition<
  typeof publicOnMemberAboutUpdated
> &
  typeof publicOnMemberAboutUpdated = createEventModule(
  publicOnMemberAboutUpdated
);

export {
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  Type,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  Origin,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SortOrder,
  WebhookIdentityType,
} from './members-about-v2-member-about-members-about.universal.js';
export {
  MemberAbout,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  Settings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  CreateMemberAboutRequest,
  CreateMemberAboutResponse,
  UpdateMemberAboutRequest,
  UpdateMemberAboutResponse,
  DeleteMemberAboutRequest,
  DeleteMemberAboutResponse,
  GetMemberAboutRequest,
  GetMemberAboutResponse,
  GetMyMemberAboutRequest,
  GetMyMemberAboutResponse,
  QueryMemberAboutsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryMemberAboutsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  MemberAboutCreatedEnvelope,
  MemberAboutDeletedEnvelope,
  MemberAboutUpdatedEnvelope,
  UpdateMemberAbout,
  MemberAboutsQueryResult,
  MemberAboutsQueryBuilder,
  MemberAboutQuerySpec,
} from './members-about-v2-member-about-members-about.universal.js';
export { utils } from './members-about-v2-member-about-members-about.universal.js';
export {
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  TypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  OriginWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  MemberAboutQuery,
} from './members-about-v2-member-about-members-about.universal.js';
